const lshift = (a, b) => a << b;
export default lshift;
